import { z } from 'zod/mini'

import { checkoutItemWithShippingSchema } from './cart-item'
import { gtmMetadataShape } from './gtm-metadata'
import { nonEmptyString } from './non-empty-string'
import { requireItemsUnlessTradeInOnly } from './require-items-unless-trade-in-only'
import { tradeInDetailsSchema } from './trade-in-details'

export const addPaymentInfoSchema = z
  .strictObject({
    ...gtmMetadataShape,
    event: z.literal('add_payment_info'),
    has_trade_in: z.boolean(),
    payment_is_installment: z.boolean(),
    payment_installment_count: z.number().check(z.gte(0)),
    payment_surcharge: z.number().check(z.gte(0)),
    ecommerce: z.strictObject({
      currency: nonEmptyString(),
      value: z.number().check(z.gte(0)),
      shipping: z.number().check(z.gte(0)),
      shipping_tier: z.string(),
      // `''` when no payment method code is known at submit time
      payment_type: z.string(),
      items: z.array(checkoutItemWithShippingSchema),
    }),
    trade_in_details: z.optional(tradeInDetailsSchema),
  })
  .check(requireItemsUnlessTradeInOnly())
